import { useEffect, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import type { TepXemTruoc } from '../types';

/**
 * Địa chỉ để thẻ `<img>`/`<iframe>` mở tệp gốc. Liên kết ký dùng thẳng; nội dung tệp (bản dev
 * của module) thành `blob:` URL, thu hồi khi tệp đổi hoặc màn đóng — đây là dọn tài nguyên của
 * trình duyệt, đúng việc của effect.
 */
export function useDiaChiXemTruoc(tep: TepXemTruoc | undefined): string | undefined {
  const blob = tep?.kieu === 'noi-dung' ? tep.blob : undefined;
  const diaChiBlob = useMemo(() => (blob ? URL.createObjectURL(blob) : undefined), [blob]);
  useEffect(() => () => {
    if (diaChiBlob) URL.revokeObjectURL(diaChiBlob);
  }, [diaChiBlob]);
  return tep?.kieu === 'lien-ket' ? tep.url : diaChiBlob;
}

/** Tệp văn bản thuần (CSV, TXT, bản xem trước của dữ liệu mẫu): đọc ra chữ để hiện trong `<pre>`. */
export function useNoiDungVanBan(tep: TepXemTruoc | undefined) {
  const blob = tep?.kieu === 'noi-dung' && /^text\//.test(tep.mime_type) ? tep.blob : undefined;
  return useQuery({
    queryKey: ['ocr', 'xem-truoc-van-ban', blob ? blob.size : 0, tep?.file_name],
    queryFn: () => blob!.text(),
    enabled: Boolean(blob),
    staleTime: Infinity,
  });
}
